// extracted by mini-css-extract-plugin
module.exports = {"Carousel":"az_hXb","Row":"az_iXb","Item":"az_jXb","Arrows":"az_kXb","Arrow":"az_lXb","DesktopVisible":"az_mXb","Previous":"az_nXb","Next":"az_oXb","FlippedIcon":"az_pXb"};